module.exports = __webpack_public_path__ + "media/images/front/icon_new_01-96f3f3363c071f51d68f7a70ea1947a2.svg";